import React from "react";
import { Form } from "react-bootstrap";

const CheckBoxFormik = ({ formik, field, label, inline, style }) => (
  <>
    <Form.Check
      id={field}
      name={field}
      label={label}
      checked={formik.values[field]}
      type="checkbox"
      inline={inline}
      disabled={formik.isSubmitting}
      onChange={formik.handleChange}
      isInvalid={formik.touched[field] && formik.errors[field]}
      style={style}
    />
    {formik.touched[field] && formik.errors[field] && (
      <Form.Control.Feedback type="invalid">{formik.errors[field]}</Form.Control.Feedback>
    )}
  </>
);

export default CheckBoxFormik;
